import React from "react";
import Icon from "../atoms/Icon";

const TextArea = ({
  iconName,
  label,
  width,
  text,
  readOnly,
  placeholder,
  onchange,
}) => {
  return (
    <div className={`flex flex-col w-full ${width} `}>
      <label
        htmlFor="name"
        className="text-dark-blue-200 text-12 font-normal leading-5 mb-2.5">
        {label}
      </label>
      <div className="flex flex-row bg-gray-chart-200 w-full px-3.5 gap-2.5 items-center rounded-sm  h-90 ">
        <Icon iconName={iconName} />
        <textarea
          onChange={onchange}
          disabled={readOnly}
          defaultValue={text}
          placeholder={placeholder}
          className="resize-none bg-gray-chart-200 outline-none text-dark-blue-200 text-13  w-full h-16"
        />
      </div>
    </div>
  );
};

export default TextArea;
